module.exports = __webpack_public_path__ + "img/lc_qd.8d331211.svg";